// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.

// is User admin of the current company
export const isUserAdmin = (state) => {
  const companyUuid = state.companies.company?.company_uuid;
  const memberships = state.user.user?.company_memberships;

  if (!companyUuid || !memberships) {
    return false;
  }

  return memberships.some(
    (m) => m.company_uuid === companyUuid && m.company_role === "admin",
  );
};

// is User member of the current studio
export const isStudioMember = (state) => {
  const studioMembers = state.studios.studio?.members || [];
  const userId = state.user.user?.user_id;

  if (!userId || studioMembers.length === 0) {
    return false;
  }

  return studioMembers.some(
    (member) => member?.company_member?.user_id === userId,
  );
};

const isExpired = (expiresAt) => {
  if (!expiresAt) {
    return false;
  }
  // TODO: update to get the system server time instead of client time
  const now = new Date();
  const expiryDate = new Date(expiresAt);
  return expiryDate < now;
};

export const userPendingInvitations = (state) => {
  const invites = state.user?.user?.invites || [];
  return invites.filter((el) => {
    const expiredInvite = isExpired(el.expires);
    const isValid = el.decision === null && el.revoked === false;
    return !expiredInvite && isValid;
  });
};

// Returns the status and variant for a given invitation
// possible status values: 'pending', 'accepted', 'declined', 'revoked', 'expired'
export const getInvitationStatus = (invite) => {
  const expiredInvite = isExpired(invite.expires);
  // invitation revoked
  if (invite.revoked) {
    return { status: "revoked", variant: "error" };
  }
  // invitation expired
  if (expiredInvite) {
    return { status: "expired", variant: "error" };
  }
  // invitation pending
  if (invite.decision === null && !expiredInvite) {
    return { status: "pending", variant: "info" };
  }
  // invitation accepted
  if (invite.decision === true) {
    return { status: "accepted", variant: "success" };
  }
  // invitation declined
  if (invite.decision === false) {
    return { status: "declined", variant: "warning" };
  }
  return { status: "unknown", variant: "" };
};
